import { ActionTree } from 'vuex';
import { MenusState } from "./types";
import { RootState } from "@/store/types"
import { InfoItem } from '@/common/acl';

export  const actions: ActionTree<MenusState, RootState> = {

    setTest(context, payload: string) {
        context.commit("setTest", payload)
    },

}